/**
 *  KINGZ EUROPE — interaction-deferred third-party scripts
 *  File: assets/kingz-defer-scripts.js
 *  EU 2026-10-27: matches the live EU setup. LoyaltyLion and Gorgias load from their
 *  EU app embeds ONLY (theme loaders off). The US LoyaltyLion token and the US Gorgias
 *  bundle (kingzkimonos-com) were removed so they can never load on kingzeurope.com.
 *  Stape app is the only GTM injector. Meta Pixel via the Facebook & Instagram channel.
 */

const KINGZ_DEFERRED_CONFIG = {
  loyaltylion:      false,  // EU app embed handles Crown Points (EU token) — theme loader off
  gorgias:          false,  // EU app embed handles chat — theme loader off
  zooomyapps:       false,  // Back-in-stock — loaded by Shopify ScriptTag
  klaviyo:          true,   // Klaviyo onsite (skips if the app embed already loaded it)
  judgeme:          false,  // lazy loaded via kingz-lazy-judgeme.js
  freegifts:        false,
  facebookPixel:    false,  // Facebook & Instagram channel handles the pixel
  googleTagManager: false,  // Stape app is the sole GTM injector
};

const DEFERRED_SCRIPTS = {

  zooomyapps: {
    src: 'https://zooomyapps.com/backinstock/ZooomyOrders.js',
    id:  'zooomyapps-backinstock',
    crossorigin: false,
    onLoad: function() {
      console.log('[Kingz] Zooomyapps back-in-stock loaded after user interaction.');
    }
  },

  klaviyo: {
    init: function() {
      if (window.klaviyo) {
        console.log('[Kingz] Klaviyo already present, skipping deferred load.');
        return;
      }
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = window.klaviyo.push || function() {
        (window.klaviyo._q = window.klaviyo._q || []).push(arguments);
      };
      var s = document.createElement('script');
      s.type  = 'text/javascript';
      s.async = true;
      s.id    = 'klaviyo-onsite';
      s.src   = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=JsDBhS';
      s.addEventListener('load', function() {
        console.log('[Kingz] Klaviyo loaded after user interaction.');
      });
      document.head.appendChild(s);
    },
    customLoad: true
  },
};

(function() {
  'use strict';

  var loaded = false;

  function injectScript(config) {
    if (document.getElementById(config.id)) return;
    var script = document.createElement('script');
    script.src   = config.src;
    script.id    = config.id;
    script.async = true;
    if (config.crossorigin) {
      script.crossOrigin = 'anonymous';
    }
    if (typeof config.onLoad === 'function') {
      script.addEventListener('load', config.onLoad);
    }
    document.head.appendChild(script);
  }

  function loadDeferredScripts() {
    if (loaded) return;
    loaded = true;
    setTimeout(function() {
      Object.keys(DEFERRED_SCRIPTS).forEach(function(key) {
        if (KINGZ_DEFERRED_CONFIG[key]) {
          var config = DEFERRED_SCRIPTS[key];
          if (config.customLoad && typeof config.init === 'function') {
            config.init();
          } else {
            injectScript(config);
          }
        }
      });
    }, 1000);
  }

  var TRIGGER_EVENTS = ['mousemove', 'touchstart', 'keydown', 'scroll', 'click'];
  TRIGGER_EVENTS.forEach(function(eventName) {
    window.addEventListener(eventName, loadDeferredScripts, {
      once:    true,
      passive: true,
    });
  });

  setTimeout(loadDeferredScripts, 5000);

})();
